"use client";
import type { FilterForm, FilterFormValues, FilterValueChange } from "@/components/filters/FilterDropdown";
import { FilterType } from "@/constants/filter";
import type { ComboFilterOption } from "./FilterCombobox";
import { FilterCombobox } from "./FilterCombobox";

export default function SelectFilter({
  type,
  onChange,
  form,
  name,
  options,
  isLoading,
}: {
  type: FilterType;
  onChange?: FilterValueChange;
  form: FilterForm;
  name: keyof FilterFormValues;
  options: ComboFilterOption[];
  isLoading?: boolean;
}) {
  if (!form) return null;

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <form.Field
      name={name}
      listeners={{
        onChange: (value) => {
          onChange?.(name, value.value);
        },
      }}
    >
      {(field) => {
        return (
          <FilterCombobox
            options={options}
            selected={field.state.value as string[]}
            onChange={(value) => {
              field.handleChange(value as string[]);
            }}
            type={type === FilterType.MULTI_SELECT ? "multi" : "single"}
            isLoading={false}
          />
        );
      }}
    </form.Field>
  );
}
